export default __webpack_public_path__ + "static/media/logo2.9d05359a.png";